module.exports = __webpack_public_path__ + "img/logo.538c3f73.png";